import { ApiClient } from '@/lib/apiClient';
import type { CreateSustainabilityData, SustainabilityData } from '@/types/sustainabilityData';

export default class SustainabilityDataService extends ApiClient<SustainabilityData, CreateSustainabilityData> {
  constructor() {
    super('/v1/sustainabilitydata', 'number');
  }
  async getLinkedToInbound(ids: number[], signal?: AbortSignal): Promise<SustainabilityData[]> {
    const response = await this.apiClient.post<SustainabilityData[]>(`/linkedtoinboundnumber`, {
      inboundIdList: ids,
    }, {
      signal,
    })
    return response.data
  }
  async getLinkedToOutbound(ids: number[], signal?: AbortSignal): Promise<SustainabilityData[]> {
    const response = await this.apiClient.post<SustainabilityData[]>(`/linkedtooutboundnumber`, {
      outboundIdList: ids,
    }, {
      signal,
    })
    return response.data
  }
}
